import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import GridToggle from "app/static/frontend/components/GridToggle"

import { isFeatureEnabled } from "shared/featureflags/helperFunctions"

const Wrapper = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: flex-start;

    > :not(:last-child) {
        margin-bottom: 11px;
    }

    font-size: 16px;
`

const cleanerOptions = [
    {
        key: 1,
        label: "Keep Font Size",
        value: "font-size",
    },
    {
        key: 2,
        label: "Keep Font Color",
        value: "color",
    },
]

const SummernoteHTMLCleanerOptions = ({ onChange }) => {
    const [selectedOptions, setSelectedOptions] = useState([])

    const Grid = ({ shouldRenderNewToggles }) => (
        <GridToggle
            bsColWidth={6}
            multi
            onChange={(values) => {
                setSelectedOptions(values)
                if (onChange) {
                    // Callback for QuorumAlert
                    onChange(values)
                }
            }}
            options={cleanerOptions}
            value={selectedOptions}
            shouldRenderNewToggles={shouldRenderNewToggles}
        />
    )

    return (
        <Wrapper>
            <span>Choose how your text should appear</span>
            <Grid shouldRenderNewToggles />
        </Wrapper>
    )
}

SummernoteHTMLCleanerOptions.propTypes = {
    onChange: PropTypes.func,
}

export default SummernoteHTMLCleanerOptions
